<script>
  import {
    FirebaseApp,
    User,
    Doc,
    Collection,
    collectionStore
  } from "sveltefire";

  import firebase from "firebase/app";
  import "firebase/firestore";
  import "firebase/auth";
  import "firebase/performance";
  import "firebase/analytics";

  import ClapOne from "./Clap2.svelte";
  import ClapTwo from "./Clap1.svelte";

  let firebaseConfig = {
    apiKey: "AIzaSyCjZNpmy9czONfzcgeDOd9JdYdtamaolrw",
    authDomain: "clapsforthenhs.firebaseapp.com",
    databaseURL: "https://clapsforthenhs.firebaseio.com",
    projectId: "clapsforthenhs",
    storageBucket: "clapsforthenhs.appspot.com",
    messagingSenderId: "845348891095",
    appId: "1:845348891095:web:a4eee4f3473da559e5c392",
    measurementId: "G-NMSTG48408"
  };

  firebase.initializeApp(firebaseConfig);

  let clapped = false;
  let audios = ["clap1", "clap2", "clap3", "clap4", "clap5", "clap6", "clap7"];

  let audioElements = document.querySelectorAll("audio");
  for (var i = 0; i < audioElements.length; i++) {
    console.log(audioElements[i]);
  }

  let loadClap;
</script>

<style>
  main {
    text-align: center;
    padding: 1em;
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #005bbb;
  }

  .button {
    width: 60px;
    height: 60px;
    margin-top: 50px;
    /* border: 1px solid blue; */
    border-radius: 999px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    cursor: pointer;
    user-select: none;
    fill: white;
    transition: all 250ms ease-in-out;
  }

  .button:hover {
    transform: scale(1.4) rotate(-4deg);
  }

  audio {
    display: none;
  }

  .count {
    color: white;
    font-size: 1.7rem;
  }

  img {
    margin-bottom: 20px;
    width: 240px;
  }

  .description {
    color: white;
    max-width: 380px;
    margin-bottom: 60px;
    opacity: 0.8;
    /* font-style: italic; */
    font-size: 0.8rem;
    transition: all 500ms ease-in-out;
    line-height: 150%;
  }

  .description:hover {
    opacity: 1;
  }

  .cred {
    position: fixed;
    bottom: 8px;
    right: 8px;
    opacity: 0.2;
    transition: all 500ms ease-in-out;
    color: white;
    text-decoration: none;
    font-size: 0.7rem;
  }

  .cred:hover {
    opacity: 1;
    text-decoration: underline;
  }

  .disclaimer {
    position: fixed;
    width: 380px;
    left: 50%;
    margin-left: -190px;
    bottom: 24px;
    opacity: 0.2;
    transition: all 500ms ease-in-out;
    color: white;
    text-decoration: none;
    font-size: 0.7rem;
    transition: all 500ms ease-in-out;
  }

  .disclaimer:hover {
    opacity: 1;
  }
</style>

<main>

  <audio id="clap1" src="claps/1.mp3" type="audio/mpeg" />
  <audio id="clap2" src="claps/2.mp3" type="audio/mpeg" />
  <audio id="clap3" src="claps/3.mp3" type="audio/mpeg" />
  <audio id="clap4" src="claps/4.mp3" type="audio/mpeg" />
  <audio id="clap5" src="claps/5.mp3" type="audio/mpeg" />
  <audio id="clap6" src="claps/6.mp3" type="audio/mpeg" />
  <audio id="clap7" src="claps/7.mp3" type="audio/mpeg" />
  <!-- 1. 🔥 Firebase App -->
  <FirebaseApp {firebase}>
    <Doc
      path={'claps/totalClaps'}
      let:data={claps}
      let:ref={clapsRef}
      on:data={() => {
        document
          .getElementById(audios[Math.floor(Math.random() * audios.length)])
          .play();
      }}
      on:ref>
      <a href="https://www.nhs.uk/conditions/coronavirus-covid-19/">
        <img src="nhs.png" alt="nhs logo" />
      </a>
      <div class="description">
        Click the clap icon to virtually clap in your web browser and the
        browser of anyone else who has this website open.
        <br />
        Virtual, realtime, applause (kinda).
        <br />
        <strong>Stay home. Keep clapping.</strong>
      </div>
      <div class="count">{claps.count} total virtual claps</div>

      <div
        class="button"
        on:click={() => {
          clapsRef.update({ count: claps.count + 1 });
          clapped = !clapped;
        }}>

        {#if clapped == true}
          <ClapOne />
        {:else}
          <ClapTwo />
        {/if}

      </div>
      <div class="disclaimer">
        This website is in no way affiliated with the NHS. It's merely an
        appreciation of the hard working heroes saving the country as we speak.
        For official health advice and information, please visit the official
        <a href="https://nhs.uk">NHS website</a>
        .
      </div>
      <div class="cred">
        <a href="https://twitter.com/rich_cahill" target="_blank">
          @rich_cahill
        </a>
      </div>
    </Doc>

  </FirebaseApp>

</main>

<!-- Styles -->
